import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b4d7d3b4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d7d3b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4d7d3b4')) {
      api.createRecord('b4d7d3b4', component.options)
    } else {
      api.reload('b4d7d3b4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b4d7d3b4&scoped=true", function () {
      api.rerender('b4d7d3b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/application/wxAccount/index.vue"
export default component.exports